// extracted by mini-css-extract-plugin
module.exports = {"logo":"ai5_cz","menu":"ai5_ia"};